import React from "react";
import {StoreContext} from "./stores/context";
import rootStore from "./stores/rootStore";
import { observer } from "mobx-react";

import Tarif from "./components/Tarif";


function App() {
  return (
    <StoreContext.Provider value={new rootStore()}>
      <Tarif />
    </StoreContext.Provider>
  );
}

export default observer(App);
